<template>
  <div class="bottom-bar">
    <div class="bottom-footer" :style="bottomBgInfo">
      <div class="bottom-con" :style="{
        height: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos.navH  + 'px' : '100px'
      }">
        <div class="bottom-content">
          <div
            class="bottom-content-item" 
            v-for="item in fontList"
            :key="item"
            :style="{
              left: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos[item].x + 'px' : bottomPos[item].x + 'px',
              top: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos[item].y + 'px' : bottomPos[item].y + 'px',
              width: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos[item].w + 'px' : bottomPos[item].w + 'px',
              height: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos[item].h + 'px' : bottomPos[item].h + 'px',
            }" 
            :class="item === 'secondContentPlice' ? 'plice' : ''"
            v-show="isShowBottomNavBarContent[appenFiled(item)]">
            <img
              v-if="item === 'secondContentPlice'"
              class="bottom-content-second-img"
              src="https://bigdata.topeti.com/PCRepository/middleground/home/images/beian.png"
            />
            <div :style="[bottomNavData.bottomContentInfo.bottomFontStyle[`${item}FontStyle`],{lineHeight: `${parseInt(bottomNavData.bottomContentInfo.bottomFontStyle[`${item}FontStyle`].fontSize) * 2}px`}]" v-html="bottomNavData.bottomContentInfo[item]"></div>
          </div>
          <div
            class="bottom-img"
            v-if="isShowBottomNavBarContent.contentImg"
            :style="{
              left: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos.contentImg.x + 'px' : '1320px',
              top: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos.contentImg.y + 'px' : '12px',
              width: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos.contentImg.w + 'px' : '80px',
              height: isBottomPos ? bottomNavData.bottomContentInfo.bottomPos.contentImg.h + 'px' : '80px',
            }"
          >
            <img
              class="bottom-img-img"
              :src="
                bottomContent.bottomContentInfo.bottomImg.includes('middleground/home/images/ewm.png')
                  ? 'https://bigdata.topeti.com/PCRepository/middleground/home/images/ewm.png'
                  : `${$url}${bottomContent.bottomContentInfo.bottomImg}`
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomNavBar",
  data() {
    return {
      fontList: ['firstContent', 'secondContent', 'secondContentPlice', 'secondContentPhone'],
      bottomContent: {
        bottomContentInfo: {
          firstContent: "",
          secondContent: "",
          secondContentPhone: "",
          secondContentPlice: "",
          bottomFontStyle: {
            firstContentFontStyle: {},
            secondContentFontStyle: {},
            secondContentPhoneFontStyle: {},
            secondContentPliceFontStyle: {},
          },
          bottomImg: "",
        },
      },
      bottomPos: {
        navH: 100,
        firstContent: {
          x: 0,
          y: 21,
          w: 'auto',
          h: 'auto'
        },
        secondContent: {
          x: 0,
          y: 42,
          w: 'auto',
          h: 'auto'
        },
        secondContentPlice: {
          x: 470,
          y: 64,
          w: 'auto',
          h: 'auto'
        },
        secondContentPhone: {
          x: 0,
          y: 64,
          w: 'auto',
          h: 'auto'
        },
        contentImg: {
          x: 1320,
          y: 12,
          w: 80,
          h: 78
        }
      },
      isShowUploadImg: false, //控制上传图片的出现
      isShowBottomNavBarContent: {
        // 控制底部导航栏的内容显示
        firstContent: true,
        secondContent: true,
        contentPolice: true,
        contentIPC: true,
        contentImg: true,
      },
      funBottom: [
        "firstContent",
        "secondContent",
        "contentPolice",
        "contentIPC",
        "contentImg",
      ],
      bottomBgInfo: {
        backgroundImage: '',
        backgroundColor: ''
      },
      bottomImg: "https://bigdata.topeti.com/PCRepository/middleground/home/images/ewm.png",
      isBottomPos: false
    };
  },
  props: {
    bottomNavData: {
      type: Object,
      default: function(){
        return {}
      },
    },
    isDesk: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    bottomNavData: {
      handler (val) {        
        Object.assign(this.bottomContent, val);
        this.setBg();
        this.isBottomPos = val.bottomContentInfo.bottomPos !== undefined
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    Object.assign(this.bottomContent, this.bottomNavData);
    this.setBg();
  },
  methods: {
    appenFiled (item) {
      // 由于以前的名字没统一 在这边转化一下
      const obj = {
        secondContentPhone: 'contentIPC',
        secondContentPlice: 'contentPolice'
      }
      if (obj[item] === undefined) return item
      else return obj[item]
    },
    // 切换底部导航背景色&背景图片
    getBottomColor(color) {
      document
        .getElementsByTagName("body")[0]
        .style.setProperty("--bottom-color", color);
    },
    // 控制模块显示、隐藏
    handleContentIsShow(arr) {
      const newArr = this.funBottom.filter((item) => arr.indexOf(item) === -1);
      newArr.forEach((item) => {
        this.isShowBottomNavBarContent[item] = false;
      });
      arr.forEach((item) => {
        this.isShowBottomNavBarContent[item] = true;
      });
    },
    // 初始化设置背景
    setBg(){
      if(Object.prototype.hasOwnProperty.call(this.bottomContent.bottomStyle, "backGroundInfo")){
        switch (this.bottomContent.bottomStyle.backGroundInfo.radio) {
          case "image":
            this.bottomBgInfo.backgroundImage = `url(${this.$url}${this.bottomContent.bottomStyle.backGroundInfo.imageUrl})`
            this.bottomBgInfo.backgroundColor = '';
            break;
          case "color":
            this.bottomBgInfo.backgroundImage = '';
            this.bottomBgInfo.backgroundColor = this.bottomContent.bottomStyle.backGroundInfo.color;
            break;
        }
      }
      this.handleContentIsShow(this.bottomContent.bottomStyle.useFun);
    }
  },
};
</script>
<style lang='scss' scoped>

.cusomdesk-bottom-bar {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0;
  margin: 0;
  z-index: 999;
}

.bottom-bar {
  .bottom-footer {
    display: flex;
    justify-content: center;
    background: #000 no-repeat center 0;
    background-position: center 0;
    background-size: cover;
    font-size: 12px;
    color: #fff;
    .bottom-con {
      display: flex;
      width: 1400px;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      height: 100%;
      transform: translate(0,0) !important;
    }
    .plice {
      display: flex;
      align-items: center;
      .bottom-content-second-img {
        width: 21px;
        margin-right: 10px;
      }
    }
    .bottom-content {
      width: 100%;
      height: 100%;
      &-item {
        position: absolute;
      }
    }
    .bottom-img {
      position: absolute;
      overflow: hidden;
      .bottom-img-img {
        width: 100%;
        height: 100%;
      }
      .bottom-img-edit {
        position: absolute;
        text-align: center;
        line-height: 19px;
        top: 0;
        right: 0;
        width: 19px;
        height: 19px;
        background: rgba(0, 0, 0, 0.438);
        font-size: 14px;
        color: #fff;
        cursor: pointer;
        opacity: 0;
        transition: all 0.5s;
      }
      .upload {
        position: absolute;
        top: -110px;
        left: 70px;
        z-index: 999;
      }
    }
    .bottom-img:hover {
      .bottom-img-edit {
        opacity: 1;
        transition: all 0.5s;
      }
    }
  }
}
</style>